import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Button, Container, Paper, Checkbox } from '@material-ui/core';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import {
  // getLocale,
  getLocaleForCategories,
  countryListWithoutVIUS as countryList,
  scrollToTop,
} from 'util/icwUtility';
import Select from 'react-select';
import { TextField } from 'icw-components/InputFields';

const useStyles = makeStyles((theme) => ({
  alink: {
    color: '#005EFF',
    textDecoration: 'none',
  },
  container: {
    width: 'auto',
    height: '100%',
  },
  msgContainer: {
    padding: '40px',
    maxWidth: '850px',
    height: '100vh',
  },
  productThumbnail: {
    width: '96px',
    height: '96px',
    padding: '20px',
    position: 'relative',
    '& > img': {
      display: 'inline-block',
      width: '100%',
    },
  },
  '@media screen and (min-width: 767px)': {
    paper: {
      padding: '10px 40px',
      marginTop: '20px',
    },
  },
  '@media screen and (max-width: 767px)': {
    paper: {
      padding: '10px 20px',
    },
  },
  errors: {
    borderColor: '#f44336',
  },
  removeBtn: {
    position: 'absolute',
    top: '0',
    right: '0',
  },
  formControl: {
    padding: '0 10px',
  },
  backBtn: {
    color: '#005EFF',
    backgroundColor: '#fff',
    borderRadius: '2px',
    border: '1px solid #005EFF',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  saveBtn: {
    color: '#fff',
    backgroundColor: '#005EFF',
    borderRadius: '2px',
    '&:hover': {
      backgroundColor: '#005EFF',
    },
  },
  backToDashboardBtn: {
    textTransform: 'uppercase',
  },
  clienSubtitle1: {
    display: 'block',
    '& span': {
      color: '#005EFF',
    },
  },
  gridMargin: {
    marginTop: '20px',
  },
}));

const businessType = [
  { label: T.translate('businessType.retailers'), value: 'retailers' },
  { label: T.translate('businessType.distributor'), value: 'distributor' },
  { label: T.translate('businessType.tradingCompany'), value: 'tradingCompany' },
  { label: T.translate('businessType.manufacturers'), value: 'manufacturers' },
  { label: T.translate('businessType.factory'), value: 'factory' },
  { label: T.translate('businessType.rawMaterial'), value: 'rawMaterial' },
];

const BuyerForm = ({
  formik,
  handleSelectChange,
  handleSelectTouched,
  productCategories,
  setStepper,
  agreeTerm,
  setAgreeTerm,
}) => {
  const classes = useStyles();

  const [readySubmit, setReadySubmit] = React.useState(false);

  const handleNextPage = () => {
    setStepper({
      selectPlan: true,
      submitForm: false,
      selectedPlan: false,
    });
    scrollToTop();
  };

  useEffect(() => {
    if (
      formik.values.companyName &&
      formik.values.country &&
      formik.values.businessTypes.length &&
      formik.values.productCategories.length &&
      formik.values.countryCode &&
      formik.values.phone &&
      formik.values.contactPerson &&
      formik.values.email &&
      agreeTerm
    ) {
      setReadySubmit(true);
    } else {
      setReadySubmit(false);
    }
  }, [formik.values, agreeTerm]);

  return (
    <div className={classes.root}>
      <Box bgcolor='#F4F6FA' height='100%'>
        <Container classes={{ maxWidthMd: classes.container }} component='div' maxWidth='md'>
          <Box display='flex' py={2}>
            <Box
              fontSize='28px'
              fontWeight='bold'
              color='#232B3A'
              justifyContent='center'
              alignItems='center'
              lineHeight='normal'
              textAlign='center'>
              {T.translate('iSource.buyerForm.title')}
            </Box>
          </Box>
          <Paper classes={{ root: classes.paper }}>
            <Box py={2}>
              <Grid container spacing={2} justify='center' alignItems='center'>
                <Grid item xs={12} sm={12} md={12}>
                  <Box
                    fontSize='20px'
                    color='#1D293F'
                    diplay='flex'
                    justifyContent='center'
                    textAlign='center'>
                    {T.translate('iSource.buyerForm.subTitle')}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Box
                    fontSize='16px'
                    fontWeight='bold'
                    color='#1D293F'
                    diplay='flex'
                    justifyContent='center'
                    py={1}>
                    {T.translate('iSource.buyerForm.companyDetail.title')}
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.form.companyName')}*
                  </Box>
                  <TextField
                    name='companyName'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.companyName')}
                    value={formik.values.companyName}
                    error={!!(formik.touched.companyName && formik.errors.companyName)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.companyName && formik.errors.companyName}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.companyDetail.country')}
                  </Box>
                  <Select
                    name='country'
                    styles={{
                      control: (base) => ({
                        ...base,
                        marginTop: '8px',
                        marginBottom: '4px',
                        padding: '1px 0',
                        backgroundColor: 'transparent',
                        '&:hover': {
                          borderColor: '#000',
                        },
                        borderColor:
                          formik.touched.country && formik.errors.country
                            ? '#f44336'
                            : 'rgba(0, 0, 0, 0.23)',
                      }),
                    }}
                    options={countryList.map((rec) => ({
                      label: T.translate(`country.${rec.region}`),
                      value: rec.region,
                    }))}
                    defaultValue={formik.country}
                    onChange={(values) => handleSelectChange(values, 'country')}
                    onBlur={(values) => handleSelectTouched(values, 'country')}
                    error={!!(formik.touched.country && formik.errors.country)}
                    placeholder={T.translate('iSource.placeholder.country')}
                  />

                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.country && formik.errors.country}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                classes={{ root: classes.gridMargin }}
                container
                spacing={2}
                justify='flex-start'>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.companyDetail.businessType')}
                  </Box>
                  <Select
                    name='businessType'
                    styles={{
                      control: (base) => ({
                        ...base,
                        marginTop: '8px',
                        marginBottom: '4px',
                        padding: '1px 0',
                        backgroundColor: 'transparent',
                        '&:hover': {
                          borderColor: '#000',
                        },
                        borderColor:
                          formik.touched.businessType && formik.errors.businessType
                            ? '#f44336'
                            : 'rgba(0, 0, 0, 0.23)',
                      }),
                    }}
                    options={businessType}
                    defaultValue={formik.businessType}
                    onChange={(values) => handleSelectChange(values, 'businessTypes')}
                    onBlur={(values) => handleSelectTouched(values, 'businessTypes')}
                    error={!!(formik.touched.businessType && formik.errors.businessType)}
                    isMulti
                    placeholder={T.translate('iSource.placeholder.options')}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.businessType && formik.errors.businessType}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                classes={{ root: classes.gridMargin }}
                container
                spacing={2}
                justify='flex-start'>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.companyDetail.companyWebSite')}
                  </Box>
                  <TextField
                    name='website'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.companyWebSite')}
                    value={formik.values.website}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box py={2}>
              <Grid container spacing={2} justify='flex-start'>
                <Grid item xs={12} sm={12} md={12}>
                  <Box fontSize='16px' fontWeight='bold' py={1}>
                    {T.translate('iSource.buyerForm.contactDetails.title')}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.contactDetails.companyAddress')}
                  </Box>
                  <TextField
                    name='address'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.companyAddr')}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>
              <Grid classes={{ root: classes.gridMargin }} container>
                <Grid item xs={12} sm={12} md={12}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.contactDetails.telephone')}
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2} justify='flex-start'>
                <Grid item xs={4} sm={4} md={2}>
                  <TextField
                    name='countryCode'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.areaCode')}
                    value={formik.values.countryCode}
                    error={!!(formik.touched.countryCode && formik.errors.countryCode)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.countryCode && formik.errors.countryCode}
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={6}>
                  <TextField
                    name='phone'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.phoneNumber')}
                    value={formik.values.phone}
                    error={!!(formik.touched.phone && formik.errors.phone)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.phone && formik.errors.phone}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                classes={{ root: classes.gridMargin }}
                container
                spacing={2}
                justify='flex-start'>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.contactDetails.contactPerson')}
                  </Box>
                  <TextField
                    name='contactPerson'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.contactPerson')}
                    value={formik.values.contactPerson}
                    error={!!(formik.touched.contactPerson && formik.errors.contactPerson)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.contactPerson && formik.errors.contactPerson}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.contactDetails.companyEmail')}
                  </Box>
                  <TextField
                    name='email'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.companyEmail')}
                    value={formik.values.email}
                    error={!!(formik.touched.email && formik.errors.email)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {!formik.errors.email ? (
                    <Box fontSize='12px' fontWeight='500' color='#8991A0'>
                      {T.translate('iSource.buyerForm.contactDetails.emailHelperText')}
                    </Box>
                  ) : (
                    formik.touched.email && (
                      <Box fontSize='12px' fontWeight='500' color='red'>
                        {formik.touched.email && formik.errors.email}
                      </Box>
                    )
                  )}
                </Grid>
              </Grid>
            </Box>
            <Box py={2}>
              <Grid container spacing={2} justify='flex-start'>
                <Grid item xs={12} sm={12} md={12}>
                  <Box fontSize='16px' fontWeight='bold' py={1}>
                    {T.translate('iSource.buyerForm.productType.title')}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.productType.productCategory')}
                  </Box>
                  <Select
                    name='productCategories'
                    styles={{
                      control: (base) => ({
                        ...base,
                        marginTop: '8px',
                        marginBottom: '4px',
                        padding: '1px 0',
                        backgroundColor: 'transparent',
                        '&:hover': {
                          borderColor: '#000',
                        },
                        borderColor:
                          formik.touched.productCategories && formik.errors.productCategories
                            ? '#f44336'
                            : 'rgba(0, 0, 0, 0.23)',
                      }),
                    }}
                    options={productCategories.map((rec) => ({
                      label: rec && rec[`name_${getLocaleForCategories()}`],
                      value: rec.id,
                    }))}
                    defaultValue={formik.productCategories}
                    onChange={(values) => handleSelectChange(values, 'productCategories')}
                    onBlur={(values) => handleSelectTouched(values, 'productCategories')}
                    error={!!(formik.touched.productCategories && formik.errors.productCategories)}
                    isMulti
                    placeholder={T.translate('iSource.placeholder.options')}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.productCategories && formik.errors.productCategories}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                classes={{ root: classes.gridMargin }}
                container
                spacing={2}
                justify='flex-start'>
                <Grid item xs={12} sm={12} md={12}>
                  <Box fontSize='12px' fontWeight='400'>
                    {T.translate('iSource.buyerForm.productType.majorProducts')}
                  </Box>
                  <TextField
                    name='majorProducts'
                    variant='outlined'
                    fullWidth
                    noLabel
                    placeholder={T.translate('iSource.placeholder.majorProducts')}
                    value={formik.values.majorProducts}
                    error={!!(formik.touched.majorProducts && formik.errors.majorProducts)}
                    setFieldTouched={formik.setFieldTouched}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    rows={5}
                    rowsMax={10}
                  />
                  <Box fontSize='12px' fontWeight='500' color='red'>
                    {formik.touched.majorProducts && formik.errors.majorProducts}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box display='flex' alignItems='center'>
              <Checkbox
                classes={{ root: classes.checkbox }}
                onChange={(e) => setAgreeTerm(e.target.checked)}
                checked={agreeTerm}
              />
              <Box display='flex' fontSize='16px' fontWeight='400' mx={1} color='##232B3A'>
                {T.translate('iSource.buyerForm.icwService')}
                <a className={classes.alink} href='https://qmas.icw.io/terms-conditions/'>
                  &nbsp;{T.translate('iSource.buyerForm.termOfCondition')}&nbsp;
                </a>
              </Box>
            </Box>
            <Box display='flex' justifyContent='space-between' my={4}>
              <Button
                classes={{ root: classes.backBtn }}
                variant='contained'
                color='primary'
                onClick={() => (window.location = 'https://qmas.icw.io/anti-epidemic/')}>
                {T.translate('general.cancel')}
              </Button>
              <Button
                classes={{ root: classes.saveBtn }}
                variant='contained'
                color='primary'
                onClick={handleNextPage}
                disabled={!readySubmit}>
                {T.translate('iSource.buyerForm.requestFreeAcc')}
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </div>
  );
};

BuyerForm.propTypes = {
  classes: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  handleSelectTouched: PropTypes.func.isRequired,
  productCategories: PropTypes.array.isRequired,
  setStepper: PropTypes.func,
  agreeTerm: PropTypes.bool,
  setAgreeTerm: PropTypes.func,
  history: PropTypes.func,
};

export default BuyerForm;
